module.exports = __webpack_public_path__ + "static/media/iPhoneX_create_email.ff7a9e69.png";